import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircle, faDotCircle } from "@fortawesome/free-solid-svg-icons";

const CheckDot = (props) => {
    return (
        <div className="bg-shippify-green h-8 w-8 rounded-full justify-center items-center flex">
            <FontAwesomeIcon icon={faCheck} className="text-white text-base" />
        </div>
    );
};
const WaitDot = (props) => {
    return <FontAwesomeIcon icon={faCircle} className="text-shippify-darkGray text-3xl" />;
};
const CurrentDot = (props) => {
    return <FontAwesomeIcon icon={faDotCircle} className="text-shippify-darkGray text-3xl" />;
};
const Steps = ({ current, validateCurrent, logo }) => (
    <div>
        <div className="flex justify-center items-center flex-col mb-5">
            <div className="flex justify-center items-center flex-col text-center mt-4">
                <div className="rounded-full h-24 w-24">
                    <img src={logo} alt="" className="rounded-full h-24 w-24 object-contain bg-white border-gray-700 border" />
                </div>
                {current === "done" ? (
                    <span className="md:text-base lg:text-xl font-medium text-shippify-darkGray mt-3"> Congratulations! </span>
                ) : current === "loading" ? (
                    <span className="md:text-base lg:text-xl font-medium text-shippify-darkGray mt-3">We are creating your company </span>
                ) : current === "error" ? (
                    <span className="md:text-base lg:text-xl font-medium text-shippify-darkGray mt-3">Oops! we had a problem! </span>
                ) : (
                    <span className="md:text-base lg:text-xl font-medium text-shippify-darkGray mt-3">Create your account </span>
                )}
            </div>
        </div>

        {current !== "error" && current !== "done" && current !== "loading" && (
            <div className="h-10 grid grid-columns-3 justify-between items-centermt-4 w-1/2 mx-auto">
                <div className="flex flex-row items-center justify-center">
                    {current === "company" ? <CurrentDot /> : validateCurrent.company ? <CheckDot /> : <WaitDot />}
                </div>
                <div className="flex flex-row items-center justify-center">
                    <div className="border-b h-1 w-10"></div>
                </div>
                <div className="flex flex-row items-center justify-center">
                    {current === "user" ? <CurrentDot /> : validateCurrent.user ? <CheckDot /> : <WaitDot />}
                </div>
            </div>
        )}
    </div>
);

export default Steps;
